import * as React from 'react';
import { useStepContext } from './stepContext';
import { Fragment as _Fragment } from "react/jsx-runtime";
import { jsx as _jsx } from "react/jsx-runtime";
export const StepWrapper = props => {
  const {
    step
  } = useStepContext();

  if (step !== props.index) {
    return null;
  }

  return /*#__PURE__*/_jsx(_Fragment, {
    children: props.children
  });
};
//# sourceMappingURL=es/FormUI/Step/StepWrapper.js.map